import { render, staticRenderFns } from "./MyPagonation.vue?vue&type=template&id=6c90934c&scoped=true&"
import script from "./MyPagonation.vue?vue&type=script&lang=ts&"
export * from "./MyPagonation.vue?vue&type=script&lang=ts&"
import style0 from "./MyPagonation.vue?vue&type=style&index=0&id=6c90934c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90934c",
  null
  
)

export default component.exports